import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Components
import ConfirmationModal from "../Confirmation Modal/ConfirmationModal";
import NavigationButtons from "../Navigation Buttons/Navigation Buttons";
import NotificationsModal from "../Notifications Modal/Notifications Modal";
import SelectMemberPopup from "./SelectMemberPopup";
import "./Dashboard.css";
// API
import { dashboardDataAPI, creatwNewApplicationIncreasedAPI } from "../../api";

// Background Image
import Loader from "../Loader/Loader";
import { useStore } from "../utils/store";

const Dashboard = ({ onLogout }) => {
  const navigate = useNavigate();

  // Retrieve Zustand store functions
  const setShowEmploymentVerification = useStore(
    (state) => state.setShowEmploymentVerification
  );

  const [loading, setLoading] = useState(false);
  const [dashboardData, setDashboardData] = useState(null);
  const [showNotificationsModal, setShowNotificationsModal] = useState(false);
  const [memberPopup, setMemberPopup] = useState(false);
  const [members, setMembers] = useState([]);

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  // Fetch dashboard data
  useEffect(() => {
    async function fetchDashboardData() {
      try {
        setLoading(true);
        const response = await dashboardDataAPI();
        setLoading(false);

        if (response?.data?.response?.response === true) {
          setDashboardData(response.data);
          setMembers(response.data?.response?.data?.members || []);
        } else {
          if (response?.data?.response?.error_msg) {
            toast.error(response.data.response.error_msg);
          } else if (response.status === 200 && response.data === "Missing JWT token") {
            localStorage.clear();
            onLogout();
            navigate("/");
          }
        }

        const showEmploymentVerification = response?.data?.response?.data?.email_verifications !== 0;
        setShowEmploymentVerification(showEmploymentVerification);


      } catch (error) {
        console.error("Error fetching dashboard data:", error);
        setLoading(false);
        toast.error("Failed to load dashboard data.");
      }
    }

    fetchDashboardData();
  }, [navigate, onLogout]);

  // Button Handlers
  const handleCreateNewApplication = async () => {
    setLoading(true);
    try {
      const response = await creatwNewApplicationIncreasedAPI();
      setLoading(false);

      if (response?.data?.response?.response === true) {
        const { pointer_id, portal_refrance_no } = response.data.response.data;
        const pointerData = { pointer_id, portal_refrance_no };
        navigate("/user/create_new_application/stage_1/occupation_details", {
          state: { pointerData },
        });
      } else {
        toast.error(response?.data?.error_msg || "Failed to create new application");
      }
    } catch (error) {
      setLoading(false);
      console.error("Error creating new application:", error);
      toast.error("Failed to create new application");
    }
  };

  const handleIncompleteApplications = () => {
    navigate("/user/incomplete_applications");
  };

  const handleSubmittedApplications = () => {
    navigate("/user/submitted_applications");
  };

  const handleEmploymentPendingVerification = () => {
    navigate("/user/employment_verification_pending");
  };

  const handleForms = () => {
    navigate("/user/forms");
  };

  const handleUpdatePersonalDetails = () => {
    navigate("/user/update_profile");
  };

  const handleLogout = () => {
    setShowConfirmationModal(true);
  };

  const handleConfirmationYes = () => {
    localStorage.clear();
    onLogout();
    navigate("/");
    toast.success("Logged out successfully!");
  };

  const handleConfirmationNo = () => {
    setShowConfirmationModal(false);
  };

  const accountType = localStorage.getItem("account_type");
  const showCreateNewApplicationTab = dashboardData?.response?.data?.create_application;
  const showIncompleteApplicationTabTab = dashboardData?.response?.data?.incompleted_application_operation;

  useEffect(() => {
    if (showCreateNewApplicationTab !== undefined) {
      localStorage.setItem("showCreateNewApplicationTab", showCreateNewApplicationTab);
    }
    if (showIncompleteApplicationTabTab !== undefined) {
      localStorage.setItem("showIncompleteApplicationTabTab", showIncompleteApplicationTabTab);
    }

    const showEmploymentVerification = dashboardData?.response?.data?.email_verifications !== 0;
    localStorage.setItem("showEmploymentVerification", showEmploymentVerification);
  }, [dashboardData]);

  return (
    <>
      {loading && <Loader />}
      {/* Navigation */}
      <Row className="mx-0">
        <Col>
          <NavigationButtons
            handleUpdatePersonalDetails={handleUpdatePersonalDetails}
            handleLogout={handleLogout}
            IsDashbaord={true}
          />
        </Col>
      </Row>

      {/* Divider */}


      {/* Main Content */}
      <div
        className="d-flex justify-content-center align-items-center auto-mobile-view"
        style={{
          height: "75vh",
          margin: 0,

        }}
      >
        <Container className="py-3 ">
          {loading && (
            <div className="d-flex justify-content-center my-4">
              <Spinner animation="border" variant="success" />
            </div>
          )}

          {/* Create New Application */}
          {showCreateNewApplicationTab && (
            <Row className="justify-content-center mb-3">
               <Col md={8} lg={4}> 
                <Button
                  variant="light"
                  data="green"
                  className="w-100 d-flex align-items-center p-3 shadow-sm border-0 rounded-4 hover-effect buttons_border"
                  onClick={handleCreateNewApplication}
                  style={{
                    backgroundColor: '#fff',
                    color: '#055837',
                    fontSize: '16px',
                    fontWeight: 500,
                    height: "90px",
                  }}
                >
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{
                      width: '60px',
                      height: '60px',
                      borderRadius: '50%',
                      backgroundColor: '#055837',
                      marginRight: '12px',
                    }}
                  >
                    <img
                      src="https://api.aqato.com.au/public/app_files/dashboard/createNew.png" // ✅ Replace with your image
                      alt="Create Application"
                      width="60"
                      height="60"
                    />
                  </div>




                  <div className="d-flex flex-column flex-grow-1 align-items-start" >

                    <span className="flex-grow-1 fw-medium font-sz-20">Create New Application</span>
                  </div>
                </Button>
              </Col>
            </Row>
          )}

          {/* Incomplete Applications */}
          {showIncompleteApplicationTabTab && (
            <Row className="justify-content-center mb-3">
               <Col md={8} lg={4}>
                <Button
                  variant="light"
                  className="w-100 d-flex align-items-center p-3 shadow-sm border-0 rounded-4 hover-effect buttons_border"
                  onClick={handleIncompleteApplications}
                  style={{
                    backgroundColor: '#fff',
                    color: '#055837',
                    fontSize: '16px',
                    fontWeight: 500,
                    height: "90px",
                  }}
                >
                  {/* Icon Circle */}
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{
                      width: '60px',
                      height: '60px',
                      borderRadius: '50%',
                      backgroundColor: '#FFCC01',
                      marginRight: '12px',
                    }}
                  >
                    <img
                      src="https://api.aqato.com.au/public/app_files/dashboard/edit.png"
                      alt="Incomplete Applications"
                      width="60"
                      height="60"
                    />
                  </div>

                  {/* Text and Badge in Column */}
                  <div className="d-flex flex-column flex-grow-1 align-items-start">
                    <span className="fw-medium font-sz-20">
                      Incomplete Applications
                    </span>
                    <span
                      className=" text-black py-1"
                      style={{ fontSize: '16px' }}
                    >
                    {dashboardData?.response?.data?.incompleted_applications || 0}
                    </span>
                  </div>
                </Button>
              </Col>
            </Row>
          )}

          {/* Submitted Applications */}
          <Row className="justify-content-center mb-3">
             <Col md={8} lg={4}> 
              <Button
                variant="light"
                className="w-100 d-flex align-items-center p-3 shadow-sm border-0 rounded-4 hover-effect buttons_border"
                onClick={handleSubmittedApplications}
                style={{
                  backgroundColor: '#fff',
                  color: '#055837',
                  fontSize: '16px',
                  fontWeight: 500,
                  height: "90px",
                }}
              >
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    backgroundColor: '#055837',
                    marginRight: '12px',
                  }}
                >
                  <img
                    src="https://api.aqato.com.au/public/app_files/dashboard/submittedApplication.png" // ✅ Replace with your image
                    alt="Submitted Applications"
                    width="60"
                    height="60"
                  />
                </div>
                <div className="d-flex flex-column flex-grow-1 align-items-start">
                  <span className="flex-grow-1 fw-medium font-sz-20">Submitted Applications</span>
                  <span
                    className=" text-black py-1"
                    style={{ fontSize: '16px' }}
                  >
                    {dashboardData?.response?.data?.submitted_applications || 0}
                  </span>
                </div>
              </Button>
            </Col>
          </Row>

          {/* Employment Verification Pending */}
          {dashboardData?.response?.data?.email_verifications !== 0 && (
            <Row className="justify-content-center mb-3">
               <Col md={8} lg={4}>
                <Button
                  variant="light"
                  className="w-100 d-flex align-items-center p-3 shadow-sm border-0 rounded-4 hover-effect buttons_border"
                  onClick={handleEmploymentPendingVerification}
                  style={{
                    backgroundColor: '#fff',
                    color: '#055837',
                    fontSize: '16px',
                    fontWeight: 500,
                    height: "90px",
                  }}
                >
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{
                      width: '60px',
                      height: '60px',
                      borderRadius: '50%',
                      //backgroundColor: '#FFCC01',
                      marginRight: '12px',
                    }}
                  >
                    <img
                      src="https://api.aqato.com.au/public/app_files/dashboard/exclamation_icon.gif"
                      alt="Pending Verification"
                      width="60"
                      height="60"
                    />
                  </div>
                  <div className="d-flex flex-column flex-grow-1 align-items-start">
                    <span className="flex-grow-1 fw-medium font-sz-20">Employment Pending Verification</span>
                    <span
                      className=" text-black py-1"
                      style={{ fontSize: '16px' }}
                    >
                      {dashboardData?.response?.data?.email_verifications}
                    </span>
                  </div>
                </Button>
              </Col>
            </Row>
          )}

          {/* Forms */}
          <Row className="justify-content-center mb-3">
             <Col md={8} lg={4}>
              <Button
                variant="light"
                className="w-100 d-flex align-items-center p-3 shadow-sm border-0 rounded-4 hover-effect buttons_border"
                onClick={handleForms}
                style={{
                  backgroundColor: '#fff',
                  color: '#055837',
                  fontSize: '16px',
                  fontWeight: 500,
                  height: "90px",
                }}
              >
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    backgroundColor: '#333',
                    marginRight: '12px',
                  }}
                >
                  <img
                    src="https://api.aqato.com.au/public/app_files/dashboard/forms.png" 
                    alt="Forms"
                    width="60"
                    height="60"
                  />
                </div>
                <div className="d-flex flex-column flex-grow-1 align-items-start">
                  <span className="flex-grow-1 fw-medium font-sz-20">Application Support Files</span>
                </div>

              </Button>
            </Col>
          </Row>

          {/* Modals */}
          <ConfirmationModal
            show={showConfirmationModal}
            onHide={handleConfirmationNo}
            onConfirm={handleConfirmationYes}
            title="Confirm Logout?"
            message="Are you sure you want to log out?"
          />

          <NotificationsModal
            showNotificationsModal={showNotificationsModal}
            closeNotificationsModal={() => setShowNotificationsModal(false)}
          />

          <SelectMemberPopup
            show={memberPopup}
            onHide={() => setMemberPopup(false)}
            members={members}
            onProceedConfirm={handleCreateNewApplication}
            isLoading={loading}
          />
        </Container>
      </div>
    </>
  );
};

export default Dashboard;